import React from 'react';
import {useTranslation} from 'react-i18next';
import Typography from '@mui/material/Typography';
import {Completed} from '@vedmarket/ui-kit';
import isEmpty from 'lodash/isEmpty';

import {COLORS} from 'config/constants';
import MenuButton from 'components/common/menuButton';
import Tooltip from 'components/common/tooltip';
import CombinedCargo from '../combined_cargo';
import {getContainerDataValue, getContainerFieldItems, METHODS} from '../../index';

import './saved-method.scss';

const SavedMethod = ({summary, method, containers, onEdit}: PackagingSavedMethodProps) => {
  const {t} = useTranslation();
  if (method !== METHODS.CONTAINERS && method !== METHODS.COMBINED_CARGO) {
    return null;
  }

  const isContainers = method === METHODS.CONTAINERS;
  const isManual = !isEmpty(summary.containers_manual);
  const containersData = isManual ? summary.containers_manual : summary.containers;
  const info = getContainerFieldItems(containers, containersData).map(({code, label}) => ({
    label,
    value: getContainerDataValue(containersData, code) || 0,
  }));

  return <div className='saved-packaging-method'>
    <Completed
      onEdit={onEdit}
      MenuComponent={MenuButton}
      caption={t(isContainers ? 'calc__text__packaging__savedContainers' : 'calc__text__packaging__savedCombinedCargo')}
      backgroundColor={COLORS.GRAY_200}
      preInfo={isContainers ? <div className='saved-packaging-method__containers'>
        <div className='saved-packaging-method__heading'>
          {summary.not_enough_space_warning && <Tooltip
            content={t('calc__text__packaging__containersDoNotFitError')}
            isWarning
          />}
          <Typography variant='body2' sx={{fontWeight: 500, color: COLORS.BLACK_DARK, lineHeight: '21px', letterSpacing: 0}}>
            {t('calc__text__packaging__calculatedNumberOfContainers')}{' '}
            <Typography component='span' variant='inherit' sx={{color: COLORS.LIGHT_TEXT_DISABLED}}>
              ({t(isManual ? 'calc__text__packaging__manually' : 'calc__text__packaging__automatically')})
            </Typography>
          </Typography>
        </div>
        <Completed info={info} hasThreeRows noPadding backgroundColor={false} />
      </div> : <div className='saved-packaging-method__cargo'>
        <CombinedCargo summary={summary} />
      </div>}
    />
  </div>;
};

export default SavedMethod;
